import React, { useState, useEffect } from "react";
import {
  ChevronDown,
  ChevronRight,
  Edit2,
  Save,
  X,
  Search,
  PencilOff,
} from "lucide-react";
import { getToken } from "../auth/authConfig";
import axios from "axios";
const MultiSelectWithSearch = ({ options, value, onChange }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState(
    Array.isArray(value) ? value : []
  );
  // console.log("options multi",options)
  useEffect(() => {
    setSelectedItems(Array.isArray(value) ? value : []);
  }, [value]);

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleToggleItem = (item) => {
    const newSelectedItems = selectedItems.includes(item)
      ? selectedItems.filter((selected) => selected !== item)
      : [...selectedItems, item];

    setSelectedItems(newSelectedItems);
    onChange(newSelectedItems);
  };

  const handleRemoveItem = (item) => {
    const newSelectedItems = selectedItems.filter(
      (selected) => selected !== item
    );
    setSelectedItems(newSelectedItems);
    onChange(newSelectedItems);
  };




  return (
    <div className="space-y-3">
      {/* Search Input */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <input
          type="text"
          placeholder="Search options..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      {/* Options List */}
      <div className="border border-gray-300 rounded-md max-h-48 overflow-y-auto">
        {filteredOptions.length > 0 ? (
          <div className="p-2 space-y-1">
            {filteredOptions.map((option) => (
              <label
                key={option}
                className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selectedItems.includes(option)}
                  onChange={() => handleToggleItem(option)}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="text-sm text-gray-700">{option}</span>
              </label>
            ))}
          </div>
        ) : (
          <div className="p-4 text-center text-gray-500 text-sm">
            No options found matching "{searchTerm}"
          </div>
        )}
      </div>

      {/* Selected Items */}
      {selectedItems.length > 0 && (
        <div className="border-t pt-3">
          <div className="text-sm font-medium text-gray-700 mb-2">
            Selected ({selectedItems.length}):
          </div>
          <div className="flex flex-wrap gap-2">
            {selectedItems.map((item) => (
              <span
                key={item}
                className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full"
              >
                {item}
                <button
                  onClick={() => handleRemoveItem(item)}
                  className="ml-1 text-blue-600 hover:text-blue-800"
                >
                  <X size={12} />
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const EditModal = ({
  isOpen,
  onClose,
  onSave,
  title,
  currentValue,
  fieldType = "text",
  options = [],
  loading,
}) => {
  const [value, setValue] = useState(currentValue);
  console.log("value", value)
  console.log("typeOf", typeof (value))
  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b">
          <h3 className="text-lg font-semibold text-gray-900">Edit {title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {title}
          </label>

          {fieldType === "multiselect" ? (
            <MultiSelectWithSearch
              options={options}
              value={value}
              onChange={setValue}
            />
          ) : fieldType === "select" ? (
            <select
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          ) : fieldType === "textarea" ? (
            <textarea
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows={4}
            />
          )
            : fieldType === "date" ?
              (
                <input
                  type="date"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              )
              : (
                <input
                  type={fieldType}
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              )}
        </div>

        <div className="flex justify-end space-x-3 p-6 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            disabled={loading}
          >
            <Save size={16} />
            <span>{loading ? "Updateing.." : "Update"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const FormViewDetails = ({ formDetails, getFormInformation, currentPhase, overallProgress }) => {
  const [expandedSections, setExpandedSections] = useState({
    unitDetails: false,
    auditDetails: false,
    protocolDetails: false,
    scoringDetails: false,
  });

  const version = formDetails?.auditDetails?.find(
    (item) => item.name === "version"
  )?.value ?? 1;

  console.log("overallProgress:", overallProgress);

  const [editModal, setEditModal] = useState({
    isOpen: false,
    title: "",
    currentValue: "",
    fieldName: "",
    fieldType: "text",
    options: [],
  });

  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [auditCriteriaOptions, setAuditCriteriaOptions] = useState([]);
  const [certificationOptions, setCertificationOptions] = useState([]);

  // Fetch audit criteria options from API
  useEffect(() => {
    const fetchAuditCriteriaOptions = async () => {
      try {
        const token = await getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/api/audit/get_all_active_tech_std`,
          {
            headers: {
              "oidc-token": token,
            },
          }
        );

        if (response.status === 200 && response?.data?.standards) {
          setAuditCriteriaOptions(response?.data?.standards);
        }
      } catch (error) {
        console.error("Error fetching audit criteria options:", error);
        // Fallback to empty array if API fails
        setAuditCriteriaOptions([]);
      }
    };

    const fetchCertifications = async () => {
      try {
        const token = await getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/api/certifications`,
          {
            headers: {
              "oidc-token": token,
              Accept: "application/json",
            },
          }
        );

        if (response.status === 200 && response?.data?.certifications) {
          setCertificationOptions(response.data.certifications);
        }
      } catch (error) {
        console.error("Error fetching certifications:", error);
        // Fallback to empty array if API fails
        setCertificationOptions([]);
      }
    };

    fetchAuditCriteriaOptions();
    fetchCertifications();
  }, []);

  // Dynamic options for multi-select fields
  const getFieldOptions = (fieldName) => {
    const optionsMap = {
      certifications: certificationOptions.length > 0 ? certificationOptions : [], // Use dynamic options from API
      audit_criteria: auditCriteriaOptions, // Use dynamic options from API
      audit_type: ["Sustaining", "Gap Assessment"],
      is_fssc_conjunction: ["Yes", "No"],
    };

    return optionsMap[fieldName] || [];
  };

  // const formatDate = (dateString) => {
  //   if (!dateString) return "N/A";

  //   const date = new Date(dateString);
  //   if (isNaN(date.getTime())) return "Invalid Date";

  //   const day = date.getDate();
  //   const month = date.toLocaleString("en-US", { month: "long" });
  //   const year = date.getFullYear();

  //   const getOrdinal = (num) => {
  //     if (num > 3 && num < 21) return "th";
  //     switch (num % 10) {
  //       case 1:
  //         return "st";
  //       case 2:
  //         return "nd";
  //       case 3:
  //         return "rd";
  //       default:
  //         return "th";
  //     }
  //   };

  //   return `${day}${getOrdinal(day)} ${month} ${year}`;
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString + "T00:00:00Z"); // force UTC midnight
    if (isNaN(date.getTime())) return "Invalid Date";

    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
    const year = date.getUTCFullYear();

    const getOrdinal = (num) => {
      if (num > 3 && num < 21) return "th";
      switch (num % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };


  useEffect(() => {
    const versionItem = formDetails?.auditDetails?.find(
      (item) => item.label === "Version"
    );
    setVisible(versionItem?.value !== 1);
  }, [formDetails]);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getFieldType = (fieldName) => {
    if (fieldName.includes("email")) return "email";
    if (fieldName.includes("date")) return "date";
    if (["certifications", "audit_criteria"].includes(fieldName))
      return "multiselect";
    if (["audit_type", "is_fssc_conjunction"].includes(fieldName))
      return "select";
    if (fieldName === "audit_team") return "textarea";
    return "text";
  };

  const handleEdit = (title, currentValue, fieldName, sectionType) => {
    const fieldType = getFieldType(fieldName);
    const options = getFieldOptions(fieldName);
    console.log("currentValue", currentValue)
    console.log("sectionType", sectionType)
    console.log("fieldType", fieldType)

    // For multi-select fields, ensure currentValue is an array
    let processedValue = currentValue;
    if (fieldType === "multiselect") {
      if (typeof currentValue === "string") {
        processedValue = currentValue
          ? currentValue.split(",").map((item) => item.trim())
          : [];
      } else if (Array.isArray(currentValue)) {
        processedValue = currentValue;
      } else {
        processedValue = [];
      }
    }

    setEditModal({
      isOpen: true,
      title,
      currentValue: processedValue,
      fieldName,
      fieldType,
      options,
      sectionType,
    });
  };

  const handleSave = async (value) => {
    // Determine endpoint based on section type
    const endpoint =
      editModal.sectionType === "unitDetails"
        ? "/editform/unitdetails"
        : "/editform/auditDetails";

    const payload = {
      formId: formDetails.formId,
      columnName: editModal.fieldName,
      value: value,
    };

    const url = `${process.env.REACT_APP_SERVER_URL}/super/${endpoint}`;
    setloading(true);
    try {
      const token = await getToken();
      const response = await axios.post(url, payload, {
        headers: {
          "oidc-token": token,
        },
      });
      // console.log('API response:', response.data);
      setloading(false);
      getFormInformation(formDetails.formId);
      // Optionally show success feedback to user here
    } catch (error) {
      console.error("Error saving data:", error);
      setloading(false);

      // Optionally show error feedback to user here
    }

    // Reset modal state
    setEditModal({
      isOpen: false,
      title: "",
      currentValue: "",
      fieldName: "",
      fieldType: "text",
      options: [],
    });
  };

  // const isEditableField = (fieldName, sectionType) => {
  //   const editableFields = {
  //     unitDetails: ['qualityManager', 'qualityManagerEmail', 'certifications'],
  //     auditDetails: ['audit_criteria', 'audit_start_date', 'audit_end_date', 'audit_type', 'is_fssc_conjunction']
  //   };

  //   return editableFields[sectionType]?.includes(fieldName) || false;
  // };

  const isEditableField = (fieldName, sectionType) => {
    let editableFields = {};

    if (currentPhase === "Unit Detail" || (currentPhase === "Audit Detail" && version === 1 && overallProgress !== 'Sent Back to Auditor')) {
      editableFields = {
        unitDetails: [
          "qualityManager",
          "qualityManagerEmail",
          "certifications",
        ],
        auditDetails: [
          "audit_criteria",
          "audit_start_date",
          "audit_end_date",
          "audit_type",
          "is_fssc_conjunction",
        ],
      };
    } else {
      editableFields = {
        unitDetails: [
          "qualityManager",
          "qualityManagerEmail",
          "certifications",
        ],
        auditDetails: ["audit_start_date", "audit_end_date"],
      };
    }

    const result = editableFields[sectionType]?.includes(fieldName) || false;

    // console.log('Checking editable:', {
    //   fieldName,
    //   sectionType,
    //   currentPhase,
    //   allowed: editableFields[sectionType],
    //   result
    // });

    return result;
  };

  const AccordionSection = ({ title, sectionKey, children }) => (
    <div className="mb-4 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <button
        onClick={() => toggleSection(sectionKey)}
        className="w-full px-6 py-4 bg-gradient-to-r from-teal-500 to-teal-500 text-white font-semibold text-left flex items-center justify-between hover:from-teal-700 hover:to-teal-800 transition-all duration-200"
      >
        <span>{title}</span>
        {expandedSections[sectionKey] ? (
          <ChevronDown
            size={20}
            className="transform transition-transform duration-200"
          />
        ) : (
          <ChevronRight
            size={20}
            className="transform transition-transform duration-200"
          />
        )}
      </button>

      {expandedSections[sectionKey] && (
        <div className="p-6 bg-gray-50">{children}</div>
      )}
    </div>
  );

  const renderTable = (data, sectionType = "") => (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Field
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Response
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-16">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row, index) => (
            <tr key={index} className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {row.label}
              </td>
              <td style={{ textTransform: "capitalize" }} className="px-6 py-4 text-sm text-gray-700">
                {row.label?.includes("Date") && row.value !== "NA" && row.value
                  ? formatDate(row.value)
                  : row.value === true
                    ? "Yes"
                    : row.value === false
                      ? "No"
                      : Array.isArray(row.value)
                        ? row.value.join(", ")
                        : row.value || "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {isEditableField(row.name, sectionType) && (
                  <button
                    onClick={() =>
                      handleEdit(row.label, row.value === true ? "Yes" : row.value === false ? "No" : row.value, row.name, sectionType)
                    }
                    className="text-blue-600 hover:text-blue-800 transition-colors"
                  // disabled={currentPhase === "Unit Detail" ||   currentPhase === "Audit Details" ? false : true}
                  >
                    <Edit2 size={16} />
                    {/* {currentPhase === "Unit Detail" || currentPhase === "Audit Details" ? <Edit2 size={16} /> : <PencilOff />} */}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="max-w-8xl mx-auto p-6 min-h-screen">
      <div className="space-y-6">
        {/* Unit Details Section */}
        <AccordionSection title="Unit Details" sectionKey="unitDetails">
          {formDetails?.unitDetails?.unitDetails?.length > 0 ? (
            <>
              {renderTable(
                formDetails.unitDetails.unitDetails.filter(
                  (item) =>
                    item.name !== "responsibleDivisionId" &&
                    item.name !== "businessUnitId"
                ),
                "unitDetails"
              )}

              {formDetails.unitDetails.offSiteFields?.length > 0 && (
                <div className="mt-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    Off-Site Fields
                  </h4>
                  {renderTable(formDetails.unitDetails.offSiteFields)}
                </div>
              )}
            </>
          ) : (
            <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
              <p className="text-yellow-800">
                No Unit Details Form Available As This Phase Is Not Yet Started
              </p>
            </div>
          )}
        </AccordionSection>

        {/* Audit Details Section */}
        <AccordionSection title="Audit Details" sectionKey="auditDetails">
          {formDetails?.auditDetails?.length > 0 ? (
            <>
              {renderTable(
                formDetails.auditDetails.filter((row) => {
                  // First filter out the standard excluded fields
                  if (["form_id", "audit_focus_area", "activity", "audit_team"].includes(row.name)) {
                    return false;
                  }

                  // Apply version-based filtering for Correction Date
                  const versionItem = formDetails?.auditDetails?.find((item) => item.label === "Version");
                  const versionValue = versionItem ? parseInt(versionItem.value) : null;

                  if (versionValue === 1 && row.label === 'Correction Date') {
                    return false; // Hide Correction Date when version is 1
                  }

                  return true; // Show all other rows
                }),
                "auditDetails"
              )}

              {/* Audit Team Section */}
              {formDetails.auditDetails.find(
                (row) => row.name === "audit_team"
              ) && (
                  <div className="mt-6">
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900">
                        Audit Team
                      </h4>
                      {/* <button
                      onClick={() => handleEdit(
                        'Audit Team',
                        JSON.stringify(formDetails.auditDetails.find((row) => row.name === "audit_team")?.value || {}),
                        'audit_team',
                        'auditDetails'
                      )}
                      className="text-blue-600 hover:text-blue-800 transition-colors"
                    >
                      <Edit2 size={16} />
                    </button> */}
                    </div>

                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Additional Attendees
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Auditor Function
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {Object.entries(
                            formDetails.auditDetails.find(
                              (row) => row.name === "audit_team"
                            )?.value || {}
                          )
                            .sort(([, a], [, b]) =>
                              a === "Lead Auditor"
                                ? -1
                                : b === "Lead Auditor"
                                  ? 1
                                  : 0
                            )
                            .map(([key, value], index) => (
                              <tr
                                key={index}
                                className="hover:bg-gray-50 transition-colors"
                              >
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {key}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                                  {value}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

              {/* Audit Focus Area Section */}
              {formDetails.auditDetails.some(
                (row) =>
                  row.name === "audit_focus_area" && row.value?.length > 0
              ) && (
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">
                      Audit Focus Area
                    </h4>
                    <div className="overflow-x-auto">
                      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Audit Focus Areas
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {formDetails.auditDetails
                            .find((row) => row.name === "audit_focus_area")
                            ?.value?.map((item, index) => (
                              <tr
                                key={index}
                                className="hover:bg-gray-50 transition-colors"
                              >
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {item}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
            </>
          ) : (
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <p className="text-blue-800">Auditing in progress.</p>
            </div>
          )}
        </AccordionSection>

        {/* Protocol Details Section */}
        <AccordionSection title="Protocol Details" sectionKey="protocolDetails">
          {formDetails?.protocolDetails &&
            Object.keys(formDetails.protocolDetails).length > 0 ? (
            <div className="space-y-6">
              {/* Protocol Details Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Field
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Response
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {formDetails.protocolDetails?.protocolListArr &&
                      formDetails.protocolDetails?.protocolListArr.map(
                        (proto, index) => (
                          <tr
                            key={proto.question_id}
                            className="hover:bg-gray-50 transition-colors"
                          >
                            <td className="px-6 py-4 whitespace-wrap text-sm font-medium text-gray-900 w-1/3">
                              {proto.text}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700 w-2/3">
                              {proto.answer ? proto.answer : "N/A"}
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>

              {/* Areas of Concern */}
              {formDetails.protocolDetails.areasOfConcern?.length > 0 && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    Areas of Concern - Findings Log
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Number (#)
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Standard
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Requirement
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Details
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Evidence
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Rating
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          {visible && (
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Evidence of Correction
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {formDetails.protocolDetails.areasOfConcern.filter(
                          (item) => item.isPreviousYear === false
                        ).length > 0 ? (
                          <>
                            {formDetails.protocolDetails.areasOfConcern
                              .filter((item) => item.isPreviousYear === false)
                              .map((item, index) => (
                                <tr
                                  key={index}
                                  className="hover:bg-gray-50 transition-colors"
                                >
                                  <td className="px-4 py-4 text-sm text-gray-900">
                                    {item.number || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.standardOrTechnicalSpecification ||
                                      "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.RequirementReference || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.detailsOfNonconformity || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.evidenceOfNonconformity || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm">
                                    <span
                                      className={`px-2 py-1 text-xs font-semibold rounded-full ${item.nonconformityRating ===
                                        "Critical"
                                        ? "bg-[#fe0000]/10 text-[#fe0000]"
                                        : item.nonconformityRating ===
                                          "Major"
                                          ? "bg-[#ff8200]/10 text-[#ff8200]"
                                          : item.nonconformityRating ===
                                            "Minor"
                                            ? "bg-[#fede0f]/40 text-[#74681d]"
                                            : item.nonconformityRating ===
                                              "Opportunity for Improvement (OFI)"
                                              ? "bg-[#cbfe01] text-[green]-900"
                                              : "bg-gray-400 text-white"
                                        }`}
                                      title={item.nonconformityRating}
                                    >
                                      {(item.nonconformityRating === 'Opportunity for Improvement (OFI)' ? 'OFI' : item.nonconformityRating) || "N/A"}

                                    </span>
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.nonConformanceStatus || "N/A"}
                                  </td>
                                  {visible && (
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item.evidenceOfCorrection || "N/A"}
                                    </td>
                                  )}
                                </tr>
                              ))}
                          </>
                        ) : (
                          <tr className="hover:bg-gray-50 transition-colors">
                            <td
                              colSpan={8}
                              className="px-4 py-4 text-sm text-gray-700 text-center"
                            >
                              No Current Year Non-conformity Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {formDetails.protocolDetails.areasOfConcern?.length > 0 && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    Previous Year Non-conformity
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Number (#)
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Standard
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Requirement
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Details
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Evidence
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Rating
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Evidence of Correction
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {formDetails.protocolDetails.areasOfConcern.filter(
                          (item) => item.isPreviousYear === true
                        ).length > 0 ? (
                          <>
                            {formDetails.protocolDetails.areasOfConcern
                              .filter((item) => item.isPreviousYear === true)
                              .map((item, index) => (
                                <tr
                                  key={index}
                                  className="hover:bg-gray-50 transition-colors"
                                >
                                  <td className="px-4 py-4 text-sm text-gray-900">
                                    {item.number || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.standardOrTechnicalSpecification ||
                                      "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.RequirementReference || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.detailsOfNonconformity || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.evidenceOfNonconformity || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm">
                                    <span
                                      className={`px-2 py-1 text-xs font-semibold rounded-full ${item.nonconformityRating ===
                                        "Critical"
                                        ? "bg-[#fe0000]/10 text-[#fe0000]"
                                        : item.nonconformityRating ===
                                          "Major"
                                          ? "bg-[#ff8200]/10 text-[#ff8200]"
                                          : item.nonconformityRating ===
                                            "Minor"
                                            ? "bg-[#fede0f]/40 text-[#74681d]"
                                            : item.nonconformityRating ===
                                              "Opportunity for Improvement (OFI)"
                                              ? "bg-[#cbfe01] text-[green]-900"
                                              : "bg-gray-400 text-white"
                                        }`}
                                      title={item.nonconformityRating}
                                    >
                                      {(item.nonconformityRating === 'Opportunity for Improvement (OFI)' ? 'OFI' : item.nonconformityRating) || "N/A"}
                                    </span>
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.nonConformanceStatus || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item.evidenceOfCorrection || "N/A"}
                                  </td>
                                </tr>
                              ))}
                          </>
                        ) : (
                          <tr className="hover:bg-gray-50 transition-colors">
                            <td
                              colSpan={8}
                              className="px-4 py-4 text-sm text-gray-700 text-center"
                            >
                              No Previous Year Non-conformity Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* FSSC */}
              {formDetails.protocolDetails.ffscFindings?.length > 0 && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    FSSC Findings
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Number (#)
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Standard
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Requirement
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Details
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Evidence
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Rating
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          {visible && (
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Evidence of Correction
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {formDetails.protocolDetails.ffscFindings.filter(
                          (item) => item["Is Previous Year"] === false
                        ).length > 0 ? (
                          <>
                            {formDetails.protocolDetails.ffscFindings
                              .filter(
                                (item) => item["Is Previous Year"] === false
                              )
                              .map((item, index) => (
                                <tr
                                  key={index}
                                  className="hover:bg-gray-50 transition-colors"
                                >
                                  <td className="px-4 py-4 text-sm text-gray-900">
                                    {item["Number (#)"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item[
                                      "Standard or Technical Specifications"
                                    ] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Requirement Reference"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Details of Nonconformity"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Evidence of Non-conformity"] ||
                                      "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm">
                                    <span
                                      className={`px-2 py-1 text-xs font-semibold rounded-full ${item["Nonconformity Rating"] ===
                                        "Critical"
                                        ? "bg-[#fe0000]/10 text-[#fe0000]"
                                        : item["Nonconformity Rating"] ===
                                          "Major"
                                          ? "bg-[#ff8200]/10 text-[#ff8200]"
                                          : item["Nonconformity Rating"] ===
                                            "Minor"
                                            ? "bg-[#fede0f]/40 text-[#74681d]"
                                            : item.nonconformityRating ===
                                              "Opportunity for Improvement (OFI)"
                                              ? "bg-[#cbfe01] text-green-700"
                                              : "bg-gray-400 text-white"
                                        }`}
                                      title={item["Nonconformity Rating"]}
                                    >
                                      {(item["Nonconformity Rating"] === 'Opportunity for Improvement (OFI)' ? 'OFI' : item["Nonconformity Rating"]) || "N/A"}
                                    </span>
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["NonConformance Status"] || "N/A"}
                                  </td>
                                  {visible && (
                                    <td className="px-4 py-4 text-sm text-gray-700">
                                      {item["Evidence Of Correction"] || "N/A"}
                                    </td>
                                  )}
                                </tr>
                              ))}
                          </>
                        ) : (
                          <tr className="hover:bg-gray-50 transition-colors">
                            <td
                              colSpan={visible ? 8 : 7}
                              className="px-4 py-4 text-sm text-gray-700 text-center"
                            >
                              No FSSC Findings Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {formDetails.protocolDetails.ffscFindings?.length > 0 && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    Previous Year Non-conformity
                  </h4>
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Number (#)
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Standard
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Requirement
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Details
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Evidence
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Rating
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Evidence of Correction
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {formDetails.protocolDetails.ffscFindings.filter(
                          (item) => item["Is Previous Year"] === true
                        ).length > 0 ? (
                          <>
                            {formDetails.protocolDetails.ffscFindings
                              .filter(
                                (item) => item["Is Previous Year"] === true
                              )
                              .map((item, index) => (
                                <tr
                                  key={index}
                                  className="hover:bg-gray-50 transition-colors"
                                >
                                  <td className="px-4 py-4 text-sm text-gray-900">
                                    {item["Number (#)"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item[
                                      "Standard or Technical Specifications"
                                    ] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Requirement Reference"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Details of Nonconformity"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Evidence of Non-conformity"] ||
                                      "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm">
                                    <span
                                      className={`px-2 py-1 text-xs font-semibold rounded-full ${item["Nonconformity Rating"] ===
                                        "Critical"
                                        ? "bg-[#fe0000]/10 text-[#fe0000]"
                                        : item["Nonconformity Rating"] ===
                                          "Major"
                                          ? "bg-[#ff8200]/10 text-[#ff8200]"
                                          : item["Nonconformity Rating"] ===
                                            "Minor"
                                            ? "bg-[#fede0f]/40 text-[#74681d]"
                                            : item.nonconformityRating ===
                                              "Opportunity for Improvement (OFI)"
                                              ? "bg-[#cbfe01] text-green-700"
                                              : "bg-gray-400 text-white"
                                        }`}
                                      title={item["Nonconformity Rating"]}
                                    >
                                      {(item["Nonconformity Rating"] === 'Opportunity for Improvement (OFI)' ? 'OFI' : item["Nonconformity Rating"]) || "N/A"}
                                    </span>
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["NonConformance Status"] || "N/A"}
                                  </td>
                                  <td className="px-4 py-4 text-sm text-gray-700">
                                    {item["Evidence Of Correction"] || "N/A"}
                                  </td>
                                </tr>
                              ))}
                          </>
                        ) : (
                          <>
                            <tr>
                              <td
                                colSpan={8}
                                className="px-4 py-4 text-sm text-gray-700 text-center"
                              >
                                No Previous Year Non-conformity Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <p className="text-blue-800">Protocol in progress.</p>
            </div>
          )}
        </AccordionSection>

        {/* Scoring Details Section */}
        <AccordionSection title="Scoring Details" sectionKey="scoringDetails">
          {formDetails?.scoringDetails &&
            Object.keys(formDetails.scoringDetails).length > 0 ? (
            <div className="space-y-6">
              {/* QMS Score */}
              {formDetails.scoringDetails.qmsScore?.length > 0 && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    QMS Results
                  </h4>
                  {renderTable(
                    formDetails.scoringDetails.qmsScore.filter(
                      (row) =>
                        ![
                          "formId",
                          "id",
                          "isFfscCertificationRecommended",
                        ].includes(row.name)
                    )
                  )}
                </div>
              )}

              {/* FSSC Score */}
              {formDetails.scoringDetails.fsscScore?.length > 0 && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    FSSC Results
                  </h4>
                  {renderTable(
                    formDetails.scoringDetails.fsscScore.filter(
                      (row) => !["formId", "id"].includes(row.name)
                    )
                  )}
                </div>
              )}

              {/* Audit Conclusion */}
              {formDetails.scoringDetails["Audit Conclusion"] && (
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    Audit Conclusion
                  </h4>
                  {renderTable(
                    formDetails.scoringDetails["Audit Conclusion"].filter(
                      (row) =>
                        row.name !== "formId" &&
                        row.label !== "Is the Tech Review Done?"
                    )
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
              <p className="text-blue-800">Scoring in progress.</p>
            </div>
          )}
        </AccordionSection>
      </div>

      {/* Edit Modal */}
      <EditModal
        isOpen={editModal.isOpen}
        onClose={() => setEditModal({ ...editModal, isOpen: false })}
        onSave={handleSave}
        title={editModal.title}
        currentValue={editModal.currentValue}
        fieldType={editModal.fieldType}
        options={editModal.options}
        loading={loading}
      />
    </div>
  );
};

export default FormViewDetails;
